import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Radio, notification, Steps, Typography, Progress, Row, Col, Card } from "antd";
import UserApi from "../common/Apis/UserApi";
import { CheckCircleFilled, StarFilled } from "@ant-design/icons";
import "../Mcq/Mcq.css";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
const { Title, Text } = Typography;

const Mcq = (props) => {
  const { placement } = "topRight";
  let navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [activeQuestion, setActiveQuestion] = React.useState(0);
  const [selectedAnswer, setSelectedAnswer] = React.useState("");
  const [Questionsets, setQuestionsets] = React.useState([]);
  const [selectedAnswerIndex, setSelectedAnswerIndex] = React.useState(null);
  const [result, setResult] = React.useState({
    correctAnswers: 0,
    Totalmarks: 0,
    wrongAnswers: 0,
  });

  // State to store all answers
  const [allAnswers, setAllAnswers] = useState([]);

  // Get User Token and Email
  const token = localStorage.getItem("userToken");
  const userEmail = localStorage.getItem("userEmail");

  const { questions } = Questionsets;

  // Reset selections when moving to next question
  const resetSelections = () => {
    setSelectedAnswerIndex(null);
    setSelectedOptions([]);
    setSelectedAnswer("");
  };

  // Save current answer before moving to next question
  const saveCurrentAnswer = () => {
    if (!questions || !questions[activeQuestion]) return;

    const currentQuestion = questions[activeQuestion];
    let answer = "";

    if (currentQuestion.answerType === "RADIO") {
      answer = selectedAnswer;
    } else {
      answer = selectedOptions.join(",");
    }

    console.log(`Saving answer for question ${activeQuestion + 1}:`, {
      question: currentQuestion.question,
      answer: answer
    });

    // Update allAnswers with current question's answer
    setAllAnswers(prev => {
      const newAnswers = [...prev];
      newAnswers[activeQuestion] = {
        question: currentQuestion.question,
        answer: answer
      };
      console.log("Updated allAnswers:", newAnswers);
      return newAnswers;
    });
  };

  // Check if answer is correct
  const checkAnswer = () => {
    if (!questions || !questions[activeQuestion]) return false;

    const currentQuestion = questions[activeQuestion];
    const correctAnswer = currentQuestion.correctAnswer;

    if (currentQuestion.answerType === "RADIO") {
      // For radio buttons, compare directly
      return selectedAnswer === correctAnswer;
    } else {
      // For checkboxes, split and compare arrays
      const correctAnswers = correctAnswer.split(",");
      const areArraysEqual = (a, b) => {
        if (a.length !== b.length) return false;
        const sortedA = [...a].sort();
        const sortedB = [...b].sort();
        return sortedA.every((element, index) => element === sortedB[index]);
      };
      return areArraysEqual(correctAnswers, selectedOptions);
    }
  };

  // Click Next Button Current Question Move to Next Question Function
  localStorage.setItem("testResult", JSON.stringify(result));
  const onClickNext = () => {
    // Check if current question is answered before proceeding
    if (selectedAnswerIndex === null && selectedOptions.length === 0) {
      return;
    }

    // Save current answer before moving
    saveCurrentAnswer();

    // Check if current answer is correct and update result
    const isCorrect = checkAnswer();
    if (isCorrect) {
      setResult((prev) => ({
        ...prev,
        correctAnswers: prev.correctAnswers + 1,
        Totalmarks: prev.Totalmarks + questions[activeQuestion]?.marks,
      }));
    }

    if (activeQuestion !== questions?.length - 1) {
      resetSelections();
      setActiveQuestion((prev) => prev + 1);
    } else {
      // All questions completed, submit answers
      handleSubmit();
    }
  };

  // Handle form submission
  const handleSubmit = () => {
    // Ensure all answers are saved (including the last question)
    saveCurrentAnswer();

    // Wait a moment for state to update, then submit
    setTimeout(() => {
      // Filter out any undefined/null answers and prepare the data
      const questionAndAnswerDTOList = allAnswers
        .filter(answer => answer !== null && answer !== undefined && answer.answer !== "")
        .map(answer => ({
          question: answer.question,
          answer: answer.answer
        }));

      console.log("Final allAnswers:", allAnswers);
      console.log("Submitting questionAndAnswerDTOList:", questionAndAnswerDTOList);

      if (questionAndAnswerDTOList.length === 0) {
        api.error({
          message: "No answers to submit!",
          placement,
        });
        return;
      }

      const formData = JSON.stringify({
        questionnaireId: Questionsets?.id || 1,
        questionAndAnswerDTOList: questionAndAnswerDTOList,
        email: userEmail,
      });

      console.log("Submitting formData:", formData);

      // Submit to API
      QuestionnairesApi.QuestionSetsAnswer(formData)
        .then((response) => {
          localStorage.setItem("Totalmarks", result.Totalmarks);
          localStorage.setItem("failMark", Questionsets?.failMark);
          localStorage.setItem(
            "TotalQuestionset",
            Questionsets?.totalNumberOfQuestions
          );
          
          // Show success notification
          api.success({
            message: "Test submitted successfully!",
            placement,
          });

          setTimeout(() => {
            return navigate("/test-result");
          }, 1000);
        })
        .catch((err) => {
          console.log("API Error:", err);
          // Show error notification
          api.error({
            message: "Failed to submit test. Please try again.",
            placement,
          });
        });
    }, 100);
  };

  const onAnswerSelected = (answer, index) => {
    setSelectedAnswerIndex(index);
    setSelectedAnswer(answer);
    
    // For radio buttons, also clear any checkbox selections
    setSelectedOptions([]);

    // Auto-save answer when selected
    if (questions && questions[activeQuestion]) {
      const currentQuestion = questions[activeQuestion];
      setAllAnswers(prev => {
        const newAnswers = [...prev];
        newAnswers[activeQuestion] = {
          question: currentQuestion.question,
          answer: answer
        };
        return newAnswers;
      });
    }
  };

  const tokenVerification = useCallback(() => {
    UserApi.tokenVerification(token)
      .then((response) => {
        updateAptitudeTestStatus();
      })
      .catch((err) => {
        if (err.success === false) {
          return navigate("/");
        }
      });
  }, [token]);

  const getQuestionset = useCallback(() => {
    QuestionnairesApi.ListMCQQuestionset()
      .then((response) => {
        setQuestionsets(response?.payload);
        // Initialize allAnswers array with the correct structure
        if (response?.payload?.questions) {
          const initialAnswers = response.payload.questions.map((question, index) => ({
            question: question.question,
            answer: ""
          }));
          setAllAnswers(initialAnswers);
          console.log("Initialized allAnswers:", initialAnswers);
        }
      })
      .catch((err) => {
        console.log(err);
        return navigate("/test-fail");
      });
  }, []);

  useEffect(() => {
    getQuestionset();
    tokenVerification();
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [tokenVerification]);

  // Update Aptitude Test Status Function
  const updateAptitudeTestStatus = useCallback(() => {
    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append(`aptitudeTestStatus`, "MCQ_TEST");

    UserApi.updateAptitudeTestStatus(formData).catch((err) => {
      // Error Notification
      if (err) {
        api.error({
          message: `${err}`,
          placement,
        });
      }
    });
  }, []);
  
  const addLeadingZero = (number) => (number > 9 ? number : `0${number}`);

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionChange = (option, index) => {
    setSelectedAnswerIndex(index);
    
    let newSelectedOptions;
    if (selectedOptions.includes(option)) {
      newSelectedOptions = selectedOptions.filter((selectedOption) => selectedOption !== option);
    } else {
      newSelectedOptions = [...selectedOptions, option];
    }
    
    setSelectedOptions(newSelectedOptions);
    
    // For checkboxes, clear any radio button selection
    setSelectedAnswer("");

    // Auto-save answer when checkbox is changed
    if (questions && questions[activeQuestion]) {
      const currentQuestion = questions[activeQuestion];
      setAllAnswers(prev => {
        const newAnswers = [...prev];
        newAnswers[activeQuestion] = {
          question: currentQuestion.question,
          answer: newSelectedOptions.join(",")
        };
        return newAnswers;
      });
    }
  };

  // Calculate progress percentage
  const calculateProgress = () => {
    if (!questions || questions.length === 0) return 0;
    return Math.round(((activeQuestion + 1) / questions.length) * 100);
  };

  // Calculate total possible marks
  const calculateTotalMarks = () => {
    if (!questions || questions.length === 0) return 0;
    return questions.reduce((total, question) => total + question.marks, 0);
  };

  // Check if current question is answered
  const isQuestionAnswered = () => {
    if (!questions || !questions[activeQuestion]) return false;
    
    if (questions[activeQuestion]?.answerType === "RADIO") {
      return selectedAnswerIndex !== null;
    } else {
      return selectedOptions.length > 0;
    }
  };

  return (
    <>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        {contextHolder}
        <div className="row justify-content-center ">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={1}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <Title className="sub-title text-center pt-5">MCQ Test</Title>
          
          {/* Marks and Progress Display Section */}
          {questions && questions.length > 0 && (
            <div className="col-xl-9 col-lg-9 col-md-12 p-0 m-0 mb-4">
              <Card className="marks-display-card">
                <Row gutter={[16, 16]} align="middle">
                  <Col xs={24} sm={8}>
                    <div className="marks-item">
                      <Text strong>Current Marks:</Text>
                      <div className="marks-value">
                        <StarFilled style={{ color: "#52c41a", marginRight: 8 }} />
                        {result.Totalmarks} / {calculateTotalMarks()}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={8}>
                    <div className="marks-item">
                      <Text strong>Correct Answers:</Text>
                      <div className="marks-value">
                        <CheckCircleFilled style={{ color: "#52c41a", marginRight: 8 }} />
                        {result.correctAnswers} / {questions.length}
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={8}>
                    <div className="marks-item">
                      <Text strong>Progress:</Text>
                      <div className="progress-container">
                        <Progress 
                          percent={calculateProgress()} 
                          size="small" 
                          strokeColor={{
                            '0%': '#108ee9',
                            '100%': '#87d068',
                          }}
                        />
                        <Text type="secondary" className="progress-text">
                          {activeQuestion + 1} of {questions.length}
                        </Text>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </div>
          )}

          <div className="col-xl-9 col-lg-9 col-md-12 p-0 m-0">
            <div className="card-body p-0 ">
              {questions && (
                <>
                  {" "}
                  <div className="question-border">
                    <p className="active-question-no">
                      Question No {addLeadingZero(activeQuestion + 1)} :
                    </p>
                    <p className="question">
                      {questions[activeQuestion]?.question}
                    </p>
                    <p className="question-sub">Select the right option</p>
                    <ul className="pl-0 ml-0">
                      {questions[activeQuestion]?.options?.map(
                        (answer, index) => (
                          <div className="form-group" key={index}>
                            <label>
                              {questions[activeQuestion]?.answerType ===
                              "RADIO" ? (
                                <>
                                  <Radio
                                    onClick={() =>
                                      onAnswerSelected(answer, index)
                                    }
                                    key={answer}
                                    checked={selectedAnswerIndex === index}
                                    className={
                                      selectedAnswerIndex === index
                                        ? "selected-answer answer"
                                        : "answer"
                                    }
                                  >
                                    {index + 1}) {answer}
                                  </Radio>
                                </>
                              ) : (
                                <>
                                  <Checkbox
                                    type="checkbox"
                                    value={answer}
                                    checked={selectedOptions.includes(answer)}
                                    onChange={() =>
                                      handleOptionChange(answer, index)
                                    }
                                    className={
                                      selectedOptions.includes(answer)
                                        ? "selected-answer answer"
                                        : "answer"
                                    }
                                  >
                                    {index + 1}) {answer}
                                  </Checkbox>
                                </>
                              )}
                            </label>
                          </div>
                        )
                      )}
                    </ul>
                  </div>
                  <div className="flex-right">
                    <Button
                      type="primary"
                      className="btn btn-primary next-step"
                      onClick={onClickNext}
                      disabled={!isQuestionAnswered()}
                    >
                      {activeQuestion === questions?.length - 1
                        ? "Finish"
                        : "Next"}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <FooterRegistraion />
      </div>
    </>
  );
};

export default Mcq;